import Vue from 'vue';
import VueI18n from 'vue-i18n';
import english from './translations/trans_en';
import german from './translations/trans_de';
import espanol from './translations/trans_es';
import czech from './translations/trans_cz';
import dutch from './translations/trans_ne';

Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: 'EN',
  fallbackLocale: 'EN',
  messages: {
    EN: english,
    DE: german,
    CS: czech,
    ES: espanol,
    NL: dutch,
  },
});
